import { TableBody } from '@lmig/lmds-react-table';
import { useState, useEffect, ChangeEvent } from 'react';
import { Button } from '@lmig/lmds-react-button';
import './SimpleInputTable.scss';
import { IconCopy } from '@lmig/lmds-react-icons';
import { faPersonWalkingDashedLineArrowRight } from '@fortawesome/free-solid-svg-icons';

export interface ISimpleInputTableItem {
  name: string;
  value: string | boolean | undefined;
  options?: string[];
}

interface ISimpleInputTableProps {
  tableObject: ISimpleInputTableItem[];
  onSubmit?: (table: ISimpleInputTableItem[]) => Promise<void>;
  onReset?: () => Promise<void>;
  onUpdate?: (table: ISimpleInputTableItem[]) => void;
  disabledFields?: string[];
}

function TrueFalse({ onUpdate, disabled, defaultTrue }: { onUpdate: (value: ChangeEvent<HTMLInputElement>) => void, disabled: boolean, defaultTrue:boolean }) {
  const [isTrue, setIsTrue] = useState<boolean | null>(defaultTrue);

  const update = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value === 'true' ? true : false;
    setIsTrue(val);
    onUpdate(e);
  }
  return (
    <div className="true-false-input">
      <label htmlFor="true-input">True</label>
      <input id="true-input" type="radio" value="true" checked={isTrue === true} onChange={(e) => update(e)}
        disabled={disabled} />
      <label htmlFor="false-input">False</label>
      <input id="false-input" type="radio" value="false" checked={isTrue === false} onChange={(e) => update(e)}
        disabled={disabled} />
    </div>
  );
}

export function SimpleInputTable({
  tableObject,
  onSubmit,
  onReset,
  onUpdate,
  disabledFields,
}: ISimpleInputTableProps) {
  const [tableData, setTableData] = useState<ISimpleInputTableItem[]>([]);
  
  useEffect(() => {
    if (tableObject) {
      setTableData(tableObject);
    }
  }, [tableObject]);

  useEffect(() => {
    if (onUpdate)
      onUpdate(tableData);
  }, [tableData]);

  const handleSimpleInputItemValueChanges = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, name: string) => {
    let value = event.target.value;
    setTableData((prevTableData) => {
      return prevTableData.map((item) => {
        if (item.name === name) {
          return { ...item, value };
        }
        return item;
      });
    });

  };

  const updateValues = async () => {
    if (onSubmit) {
      await onSubmit(tableData);
      window.location.reload();
    }
  }

  const reset = async () => {
    if (onReset) {
      await onReset();
      window.location.reload();
    }
  }
  return (
    <>
      <table className="table simple-table">
        <TableBody>
          {tableData.map((tableObj) => (
            <tr key={tableObj.name}>
              <td style={{ fontWeight: 700, minWidth: '200px' }}>{tableObj.name}</td>
              <td>
                {typeof tableObj.options !== 'undefined' ? <select
                  onChange={(e) => handleSimpleInputItemValueChanges(e, tableObj.name)}>{(tableObj.options as string[]).map(x => <option selected={x === tableObj.value}>{x}</option>)}</select> :
                  typeof tableObj.value === 'boolean' || tableObj.value === "true" || tableObj.value === "false" ? <TrueFalse onUpdate={(e) => handleSimpleInputItemValueChanges(e, tableObj.name)} disabled={disabledFields?.includes(tableObj.name) ? true : false} defaultTrue={tableObj.value === "true" || tableObj.value === true}/> :

                    <input
                      type={typeof tableObj.value === 'string' ? 'text' : 'number'}
                      disabled={disabledFields?.includes(tableObj.name) ? true : false}
                      value={tableObj.value?.toString()}
                      style={{ fieldSizing: 'content', 'minWidth': '40px' }}
                      onChange={(e) => handleSimpleInputItemValueChanges(e, tableObj.name)}
                    />}
                    {tableObj.name && tableObj.name.indexOf("Agency Number") != -1 && <IconCopy className="simple-table-copy-icon" color="gray" size='16' onClick={() => typeof tableObj.value === 'string' && navigator.clipboard.writeText(tableObj.value)}/>}

              </td>
            </tr>
          ))}
        </TableBody>
      </table>
      <div className="simple-table-buttons">
        <Button
          className="update-simple-table-input-values"
          variant="primary"
          onClick={() => updateValues()}
        >
          Update Values
        </Button>
        <Button
          variant="secondary"
          onClick={() => reset()}
          className="reset-simple-table-input-values"
        >
          Reset Values
        </Button>
      </div>
    </>
  );
}
